import { resetFiltersEvent } from './filters/app-filters.js';
import { addTextSearchedBrandsToSelected, filterBrandsHandler, isBrandSelected, moveBrandtoUnselected } from './filters/brand-filter.js';
import { openDetailsOnInvalidInput } from './filters/open-details-on-invalid-input.js';
import { isApp, canCallApp, config, TYPINGDELAY } from './utils.js';
import { userAppliedFilters } from './filters/transfer-filters.js';
import * as Ajax from './utils/ajax.js';

window.addEventListener('DOMContentLoaded', async () => {

    const filtersContainer = document.querySelector('#filter-mobile-form');
    const sortingContainer = document.querySelector('.filters-container.sorting-container:not(.d-none)');
    const toggleFiltersBtn = document.querySelectorAll('.js-toggle-filters');

    if (!toggleFiltersBtn || !filtersContainer) {
        return;
    }

    //
    // Mostrar y ocultar el container de los filtros, contrayéndolos
    const body = document.querySelector('body'),
        filtersDetails = filtersContainer.querySelectorAll('.filters-list > details');
    toggleFiltersBtn.forEach(btn => btn.addEventListener('click', (e) => {
        if (sortingContainer) {
            history.back();
            return;
        }
        e.preventDefault();
        filtersDetails.forEach((detail => detail.open = false));
        filtersContainer.classList.toggle('dropup-active');
        body.classList.toggle('overflow-hidden');
        body.classList.toggle('position-relative');
    }));

    //
    // Mantener sólo un filtro visible y expandido a la vez
    filtersDetails.forEach(detail => {
        detail.addEventListener('toggle', e => {
            if (detail.open) {
                detail.scrollIntoView(true);
                filtersContainer.querySelectorAll('details[open]').forEach(openDetail => {
                    if (openDetail != e.target) {
                        openDetail.open = false;
                    }
                });
            }
        });
    });

    //
    // Mostrar el filtro seleccionado en los filtros y el breadcrumb de categorías y contraer el filtro actual
    const inputs = filtersContainer.querySelectorAll('input[type="radio"]:not([name="sortingOption"]), input[type="checkbox"]');
    inputs.forEach(input => inputFilterAddChangeListener(input));

    //
    // Listado autocompletar marcas
    const brandInput = filtersContainer.querySelector('.js-filter-brands');
    if (brandInput) {
        let brandTimer;

        brandInput.addEventListener('input', (e) => {
            clearTimeout(brandTimer);
            brandTimer = setTimeout(() => {

                let brandname = e.srcElement.value,
                    limit = 10,
                    params = {
                        limit: limit,
                    };

                if (brandname.length > 0 ) {
                    params.name = brandname;
                } else {
                    params.limit = 100;
                }
                addTextSearchedBrandsToSelected(); //When changing input text, previously checked brands are set as selected
                Ajax.get("/api/v4/brand/search", params, true)
                    .then(brands => {
                        let resultList = filtersContainer.querySelector('.js-filter-brand-result'),
                            noResults = filtersContainer.querySelector('.js-filter-brand-no-result'),
                            template = filtersContainer.querySelector('.filter-brand-template').content;
                        const selectedBrandsContainer = document.querySelector( '.js-selected-brands' );
                        resultList.classList.toggle('d-none', brands.length == 0);
                        resultList.innerHTML = '';
                        noResults.classList.toggle('d-none', brands.length > 0);
                        selectedBrandsContainer.classList.toggle( 'd-none', typeof params.name !== 'undefined' ); //Hide selected brands container when searching
                        for (const brand of brands) {
                            if ( !isBrandSelected( brand.slug ) ) {
                                const labelId = "idcheckbox-" + brand.id;
                                let details = document.importNode(template, true).querySelector('details'),
                                    input = details.querySelector('input');
                                details.querySelector('label').setAttribute('for', labelId);
                                input.id = labelId;
                                inputFilterAddChangeListener(input);
                                input.value = brand.slug;
                                input.nextElementSibling.textContent = brand.name;
                                resultList.appendChild(details);
                            }
                        }
                        if ( typeof params.name === 'undefined' ) { //When empty query, popular brands are shown. Add their title
                            const title = document.querySelector( '.js-popular-brands-header' ).content.cloneNode( true );
                            resultList.insertBefore( title, resultList.firstChild );
                        }
                    });
            }, TYPINGDELAY);
        });
    }

    //
    // Reset form
    const reset = filtersContainer.querySelector('input[type="reset"]');
    if (reset) {
        reset.addEventListener('click', () => {
            filtersDetails.forEach((detail => detail.open = false));
            filtersContainer.querySelectorAll('.js-selected-filter-label, .category-breadcrumb').forEach(elem => elem.textContent = '');
            filtersContainer.querySelectorAll('input[type="radio"], input[type="checkbox"]').forEach(input => {
                input.checked = false;
                input.removeAttribute('checked'); //radios & checkboxes
            });
            filtersContainer.querySelectorAll('input[type="text"], input[type="number"]').forEach(input => {
                input.removeAttribute('value'); //number
            });
            filtersContainer.querySelector('[name="no_user_sizes"]').value = 1;
            filtersContainer.querySelectorAll( '.js-selected-brands [name="brand[]"]' ).forEach( brand => {
                const brandElem = brand.closest( 'details' );
                moveBrandtoUnselected( brandElem );
            } );
        });
    }
    resetFiltersEvent();
    preventPriceErrorsOnClosedDetails();
    updateCurrentSelectedFilters();
});

function inputFilterAddChangeListener(input)
{
    input.addEventListener('change', e => {
        let current = e.target,
            label = current.nextElementSibling.textContent,
            filter = current.closest('.filters-list > details[open]'),
            selectedFilterLabel = filter.querySelector('summary .js-selected-filter-label'),
            selectedCheckboxes = filter.querySelectorAll('input[type="checkbox"]:checked');

        // requested by noguera, delete user query whenever she selects a category, in apps only
        if (isApp && current.name === 'category') {
            document.querySelectorAll('input[name="txt"]').forEach((el) => {
                el.value = '';
            });
        }

        if (current.name === "sizes[]") {
            document.querySelector('[name="no_user_sizes"]').value = 1;
        }

        if ( current.name === 'brand[]' ) {
            const firstChild = input.closest( '.js-filter-brand-result' )?.firstElementChild;
            if ( firstChild?.classList.contains( 'js-popular-brands-title') || input.closest( '.js-selected-brands' ) ) { //Do not use filterBrandsHandler when selecting a text searched brand
                filterBrandsHandler( current );
            }
        }

        if (current.type === 'checkbox') // Filtros con multiselect
        {
            selectedFilterLabel.textContent = '';
            selectedCheckboxes.forEach((input, index, array) => selectedFilterLabel.textContent += input.nextElementSibling.textContent.trim() + (index == array.length -1 ? '' : ', '));
            if (current.name == "category" && current.checked) { // Las categorías son checkboxes que se comportan como radiobuttons pero se pueden deseleccionar
                selectedFilterLabel.textContent = label;
                selectedCheckboxes.forEach(input => {
                    if (input != current) { //Deseleccionamos cualquier otro input
                        input.checked = false;
                    }
                });
            }
        } else { // Filtros sin multiselect
            selectedFilterLabel.textContent = label; // Mostrar filtro seleccionado en el filtro padre
            filter.removeAttribute("open");
        }

        // Marcar breadcrumb para arbol de categorías de elemento seleccionado hasta categoría principal
        let breadcrumb = filter.querySelectorAll('.category-breadcrumb');
        breadcrumb.forEach(elem => elem.textContent = ''); // Borrar breadcrumbs anteriores
        if (current.checked) {
            while (!current.parentElement.classList.contains('filters-list')) {
                let currentBreadcrumb = current.querySelector('summary .category-breadcrumb');
                if (currentBreadcrumb) {
                    currentBreadcrumb.textContent = '•';
                }
                current = current.parentElement;
            }
        }
    });
}

const preventPriceErrorsOnClosedDetails = () => {
    document.querySelectorAll( '[name="min_price"], [name="max_price"]' ).forEach( input => openDetailsOnInvalidInput( input ) );
};

const updateCurrentSelectedFilters = () => {
    const filtersForm = document.querySelector('form.filters-container');

    if (!filtersForm || !canCallApp('transferFilters')) return;

    filtersForm.addEventListener("change", handleFilterChange);
}

const handleFilterChange = (event) => {
    const input = event.target;
    if (!input || !input.hasAttribute('data-filter-name')) return;

    const { filterName } = input.dataset;

    if (!(filterName in userAppliedFilters)) return;

    if (filterName === 'category_filter') {
        userAppliedFilters[filterName][0] = input.value;
        return;
    }

    if (Array.isArray(userAppliedFilters[filterName])) {
        updateArrayFilter(input, filterName);
        return;
    }

    userAppliedFilters[filterName] = input.value;
}

const updateArrayFilter = (input, filterName) => {
    if (!input.checked) {
        userAppliedFilters[filterName] = userAppliedFilters[filterName].filter(item => item !== input.value);
        return;
    }

    userAppliedFilters[filterName].push(input.value);
}